export enum EventType {
  Update = 'Update',
  Complete = 'Complete'
}
